import { useState } from 'react';

// #207 parte 2 — indicador «Protección anti-ransomware» de un job de archivos.
// `status` es el honeypot_status que guardó el backend (lo manda el agente
// >= 1.19.4); null/undefined = sin datos.

const LEVELS = {
  active:     { label: 'activa',      color: 'var(--green)',  bg: 'rgba(0,229,160,0.12)' },
  incomplete: { label: 'incompleta',  color: 'var(--yellow)', bg: 'rgba(255,209,102,0.12)' },
  alert:      { label: 'ALERTA',      color: 'var(--red)',    bg: 'rgba(255,0,0,0.15)' },
  nodata:     { label: 'sin datos',   color: 'var(--muted)',  bg: 'var(--bg)' },
};

export function honeypotLevel(status) {
  switch (status && status.overall) {
    case 'active': return 'active';
    case 'incomplete':
    case 'none': return 'incomplete';
    case 'triggered': return 'alert';
    default: return 'nodata';
  }
}

// Motivos legibles; nunca claves técnicas del agente.
export function honeypotReasons(status) {
  const level = honeypotLevel(status);
  if (level === 'nodata') {
    return ['El agente es anterior a 1.19.4 o todavía no corrió desde la actualización: no hay información sobre los honeypots.'];
  }
  if (level === 'active') return [];
  const reasons = [];
  Object.entries(status.paths || {}).forEach(([p, s]) => {
    if (s.state === 'triggered') {
      reasons.push(`Honeypots alterados o eliminados en ${p}. Posible ransomware.`);
    } else if (s.state === 'path_missing') {
      reasons.push(`Carpeta inexistente: ${p}.`);
    }
    (s.conflicts || []).forEach(c => reasons.push(
      `Hay un archivo del cliente con nombre de honeypot (${c}); ese honeypot no se pudo armar.`));
    (s.errors || []).forEach(e => reasons.push(`No se pudo escribir un honeypot: ${e}`));
    if (s.state === 'incomplete' && !(s.conflicts || []).length && !(s.errors || []).length) {
      reasons.push(`Faltan honeypots por armar en ${p}.`);
    }
  });
  if (!reasons.length && status.overall === 'none') reasons.push('Ningún honeypot está armado.');
  return reasons;
}

export default function HoneypotIndicator({ status, actions = null }) {
  const [open, setOpen] = useState(false);
  const level = LEVELS[honeypotLevel(status)];
  const reasons = honeypotReasons(status);
  const text = `Protección anti-ransomware: ${level.label}`;
  return (
    <div style={{ marginTop: 6 }}>
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 6 }}>
        <span role="button" tabIndex={0} title={reasons.join(' ') || text}
          onClick={() => setOpen(o => !o)}
          onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') setOpen(o => !o); }}
          style={{
            display: 'inline-block', padding: '3px 8px', fontSize: 10, fontFamily: 'var(--mono)',
            letterSpacing: 1, borderRadius: 2, cursor: 'pointer', fontWeight: 700,
            background: level.bg, color: level.color,
          }}>
          {text}
        </span>
        {actions}
      </div>
      {open && reasons.length > 0 && (
        <ul style={{ margin: '6px 0 0', paddingLeft: 18, fontSize: 11, color: 'var(--muted)', fontFamily: 'var(--mono)' }}>
          {reasons.map((r, i) => <li key={i} style={{ marginBottom: 2 }}>{r}</li>)}
        </ul>
      )}
    </div>
  );
}
